import { Preview } from '@/modules/common/models/preview/preview.ts';
import {
  CLIENTS_ADDRESSES_GET,
  CLIENTS_COMMENTS_GET,
  CLIENTS_CONTACTS_GET,
} from '@/modules/core/configs/end-points.ts';
import { useCounterpartyRowStore } from '@/modules/counterparty/stores/counterparty-row.store.ts';
import { useCounterpartyAddressesStore } from '@/modules/counterparty/stores/counterparty-addresses.store.ts';
import { useCounterpartyCommentsStore } from '@/modules/counterparty/stores/counterparty-comments.store.ts';
import { useCounterpartyContactsStore } from '@/modules/counterparty/stores/counterparty-contacts.store.ts';
import { useCounterpartyDocsStore } from '@/modules/counterparty/stores/counterparty-docs.store.ts';
import { useBankDetailsStore } from '@/modules/counterparty/stores/bank-details.store.ts';
import { BankDetailsEndPoint } from '@/modules/common/enums/end-point.ts';
import { useAccessStore } from '@/modules/core/stores/access.store.ts';
import { Access } from '@/modules/common/enums/access.enum.ts';

export class ClientPreview extends Preview {
  static intefaceIdent = 'CLIENT_PREVIEW';

  fetchDataPreview(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._abort().finally(() => {
        this._fetch()
          .then(() => resolve())
          .catch((e) => reject(e));
      });
    });
  }

  fetchPartlyPreview(endPoint: string) {
    const params = {
      clientId: this._entityId!,
      limit: this._limitLoad,
      offset: 0,
    };

    switch (endPoint) {
      case CLIENTS_ADDRESSES_GET:
        return useCounterpartyAddressesStore().fetch(params);
      case CLIENTS_CONTACTS_GET:
        return useCounterpartyContactsStore().fetch(params);
      case CLIENTS_COMMENTS_GET:
        return useCounterpartyCommentsStore().fetch(params);
      case BankDetailsEndPoint.Get:
        return useBankDetailsStore().fetch({ clientId: this._entityId!, limit: this._limitLoad, offset: 0 });
    }
  }

  private _fetch() {
    const params = {
      clientId: this._entityId!,
      limit: this._limitLoad,
      offset: 0,
    };

    const counterpartyRowStore = useCounterpartyRowStore();

    const promices = [
      counterpartyRowStore.fetch(this._entityId!),
      useCounterpartyAddressesStore().fetch(params),
      useCounterpartyCommentsStore().fetch(params),
      useCounterpartyContactsStore().fetch(params),
      useCounterpartyDocsStore().fetch(params),
    ];

    const accessStore = useAccessStore();

    if (accessStore.has(Access.CounterpartiesBankDetails)) {
      promices.push(useBankDetailsStore().fetch({ clientId: this._entityId!, limit: this._limitLoad, offset: 0 }));
    }

    return Promise.all(promices);
  }

  private _abort() {
    const counterpartyRowStore = useCounterpartyRowStore();
    const promices = [
      counterpartyRowStore.abort(),
      useCounterpartyAddressesStore().abort(),
      useCounterpartyCommentsStore().abort(),
      useCounterpartyContactsStore().abort(),
      useCounterpartyDocsStore().abort(),
    ];

    const accessStore = useAccessStore();

    if (accessStore.has(Access.CounterpartiesBankDetails)) {
      promices.push(useBankDetailsStore().abort());
    }

    return Promise.all(promices);
  }
}
